(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bl-footer"] && !Shopify.designMode) return;
  try {
    (()=>{const mq=matchMedia('(max-width:749px)');document.querySelectorAll('.bl-footer').forEach(root=>{if(root.dataset.detailsReady)return;root.dataset.detailsReady='true';const details=[...root.querySelectorAll('.bl-footer__links')];const sync=()=>details.forEach(el=>{el.open=!mq.matches;el.querySelector('summary').tabIndex=mq.matches?0:-1});mq.addEventListener('change',sync);details.forEach(el=>el.querySelector('summary').addEventListener('click',e=>{if(!mq.matches)e.preventDefault()}));sync()})})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
